<div class="input-area" [class.disabled]="formControl.disabled">
  <a360-icon
    class="search-icon"
    icon="search"
    [color]="iconColors.GREY"
    [width]="!narrowMode ? iconSizes.LARGE : iconSizes.DEFAULT"
    [height]="!narrowMode ? iconSizes.LARGE : iconSizes.DEFAULT"
  ></a360-icon>
  <label class="ng6-input-label" [ngClass]="labelClass" [attr.for]="agencyTextInput.id">
    {{ inputLabel }}
    @if (isRequired) {
    <span class="asterisk">*</span>
    }
  </label>
  <input
    [id]="autId"
    [aut-id]="autId"
    dynamicId="ng6-Input"
    class="ng6-input"
    #agencyTextInput
    [type]="inputType"
    [formControl]="formControl"
    tabindex="{{ tabindex }}"
    (focus)="onFocus()"
    (blur)="onBlurInput()"
    [attr.aria-label]="inputLabel"
    [attr.aria-required]="isRequired"
  />
</div>

@if (formControl.touched && errorMessageVisible) {
<div>
  @for (error of formControl.errors | keyvalue; track error) {
  <input-error [announceError]="announceError" class="input-error-comp">
    {{ getErrorMessage(error) }}
  </input-error>
  }
</div>
}
